export default {
  magazine: {
    title: 'konfetti Magazin',
    magazine: 'Magazin',
    article: 'Artikel',
    category: 'Themengebiet',
    showMore: 'Mehr anzeigen',
    showAll: 'Alle anzeigen',
    filters: 'Filter',
    selectCategory: 'Kategorie auswählen',
    searchPlaceholder: 'Kategorien durchsuchen...',

    footerLinks: {
      title: 'Unsere Themen',
    },

    articlePage: {
      datePrefix: 'Aktualisiert am',
      supplierProfileSubtitle: 'Partner und Autor',
      relatedArticles: {
        sectionTitle: 'Artikel zu ähnlichen Themen',
      },
      supplierEvents: {
        sectionTitle: 'Entdecke Kurse von {partnerName}',
      },
      tableOfContents: 'Inhaltsverzeichnis',
    },

    authorAboutTitle: 'Über den Autor',
    authorAboutLink: 'Partner-Seite',
  },
}
